import FeaturedProduct from './Product'

export default FeaturedProduct
export { FeaturedProduct }
